module.exports = __webpack_public_path__ + "static/img/wxtp_20260714114138_97_157.b2915b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/news/20260714/wxtp_20260714114138_97_157.jpg
// module id = nJ3U
// module chunks = 0